import axios from 'axios'
import { API_ADMIN_ORDER_STATUS_CHANGE } from 'constants/urls'

export const adminChangeOrderStatus = async (data) => {
  try {
    const response = await axios.patch(`${API_ADMIN_ORDER_STATUS_CHANGE}/`, data)
    return response.data
  } catch (error) {
    console.error('Error changing order status:', error)
    throw error
  }
}
